import React, { useEffect } from 'react';
import styled from 'styled-components';
import { PageHeader } from './components/page-header';
import { Sidebar } from 'app/layouts/components/sidebar';
import { FlexRow } from '@make-software/cspr-design';
import { VersionedFooter } from 'app/layouts/components/footer';

const Container = styled.div(({ theme }) => ({
  overflow: 'auto',
  minWidth: theme.minWidth,
  width: '100%',
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'center',
  backgroundColor: theme.styleguideColors.backgroundSecondary,
  color: theme.styleguideColors.contentPrimary,
  flexDirection: 'column',
  height: '100vh'
}));

const Content = styled.div(({ theme }) =>
  theme.withMedia({
    width: '95%',
    // maxWidth: theme.maxWidth,
    flex: 1
  })
);

export interface PageLayoutProps {
  children?: React.ReactNode;
  title?: string;
  renderHeader?: () => React.ReactNode;
  hasNavBar?: boolean;
  showBreadcrumb?: boolean;
}

export const AuthorizedLayout = (props: PageLayoutProps) => {
  const { children, title } = props;

  useEffect(() => {
    document.title = `${title}`;
  }, [title]);

  return (
    <FlexRow>
      <Sidebar />
      <Container>
        <PageHeader />
        <Content>{children}</Content>
        <VersionedFooter />
      </Container>
    </FlexRow>
  );
};

export default AuthorizedLayout;
